<template>
    <div
        class="col-lg-12 pt-4 pb-4 comment-ibox"
        :class=" { 'sk-loading': loading } "
    >
        <div class="sk-spinner sk-spinner-wave">
            <div class="sk-rect1"></div>
            <div class="sk-rect2"></div>
            <div class="sk-rect3"></div>
            <div class="sk-rect4"></div>
            <div class="sk-rect5"></div>
        </div>
        <div v-if="!edit_description" id="commentDiv">
            {{ description }}
            <!-- {{ $t('add_description') }} -->
            <br>
            <div class="btn btn-xs btn-default" @click="pageDescriptionEdit" id="editBtn"> {{ $t('edit') }} </div>
        </div>
        <div v-else>
            <textarea style="width:100%" rows="7" v-model="description" id="areaComment"></textarea>
            <br>
            <div class="btn btn-xs btn-default" @click="pageDescriptionSave" id="saveBtn"> {{ $t('save') }} </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'TaskMake',
    data() {
        return {
            description: '',
            edit: false,
            loading: false,
            edit_description: false
        }
    },
    created() {
        this.description = 'Dodaj opis tej strony'
        this.loading = true
        this.edit_description = false
        this.getDescription()
    },
    watch: {
        '$route.path': function() {
            this.description = 'Dodaj opis tej strony'
            this.loading = true
            this.edit_description = false
            this.getDescription()
        }
    },
    methods: {
        getDescription() {
            this.$http.post( 'uri', {
                name: this.$route.path
            } )
                .then( resp => {
                    this.description = resp.data.description || 'Dodaj opis tej strony'
                    this.loading = false
                } )
                .catch( () => {
                    this.loading = false
                } )
        },
        pageDescriptionEdit() {
            this.edit_description = true
        },
        pageDescriptionSave() {
            this.$http.put( 'uri', {
                name: this.$route.path,
                description: this.description
            } )
                .then( () => {
                    this.loading = false
                    this.edit_description = false
                    this.$toastr.success( 'Opis zapisany' )
                } )
                .catch( () => {
                    this.loading = false
                    this.$toastr.error( 'Coś poszło nie tak' )
                } )
        }
    }
}
</script>
